// "Tue 19 – Thu 21 Jan · 3 days" that never breaks inside a part (WI-40 #7): each part stays on
// one line, and when they don't fit side by side the next part starts a new line without its "·".
// Every part leads with a separator box of the same width (the first one's is empty), and the row
// is shifted left by that width inside a clipping box: whichever part starts a line has its "·"
// clipped off (styles/screens.css `.when`). The text still reads "A · B".
export function When({ parts, className = '' }: { parts: string[]; className?: string }) {
  return (
    <small className={`when ${className}`.trim()}>
      <span className="when-in">
        {parts.map((p, i) => (
          <span key={i}>
            <span className="when-sep">{i ? ' · ' : ''}</span>
            {p}
          </span>
        ))}
      </span>
    </small>
  )
}
